import { render, staticRenderFns } from "./BlogSidebarArchive.vue?vue&type=template&id=45fe0df4&"
import script from "./BlogSidebarArchive.vue?vue&type=script&lang=js&"
export * from "./BlogSidebarArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports